'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Breadcrumbs = require('./Breadcrumbs.scss');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Breadcrumbs: {
    displayName: 'Breadcrumbs'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Breadcrumbs/Breadcrumbs.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Breadcrumbs = _wrapComponent('Breadcrumbs')((_dec = (0, _reactCssModules2.default)(_Breadcrumbs2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Breadcrumbs, _Component);

  function Breadcrumbs() {
    (0, _classCallCheck3.default)(this, Breadcrumbs);
    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
  }

  (0, _createClass3.default)(Breadcrumbs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          trip = _props.trip,
          localExpert = _props.localExpert,
          inspiration = _props.inspiration,
          customStyle = _props.customStyle;

      var separator = function separator(key) {
        return _react3.default.createElement('i', { className: 'fa fa-angle-right', styleName: 'separator', key: 'separator-' + key });
      };
      return _react3.default.createElement(
        'span',
        { styleName: 'breadcrumb', style: customStyle, itemScope: true, itemType: 'http://schema.org/BreadcrumbList' },
        _react3.default.createElement(
          'span',
          { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem' },
          _react3.default.createElement(
            'a',
            { itemProp: 'item', href: '/' },
            _react3.default.createElement(
              'span',
              { styleName: 'breadcrumb-item', itemProp: 'name' },
              'Home'
            ),
            _react3.default.createElement('meta', { itemProp: 'position', content: '1' })
          )
        ),
        function () {
          switch (type) {
            case 'TripDetail':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'a',
                  { itemProp: 'item', href: '/to/' + encodeURIComponent(trip.destination_location) },
                  _react3.default.createElement(
                    'span',
                    { styleName: 'breadcrumb-item', itemProp: 'name' },
                    trip.destination_location
                  ),
                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
                )
              ), separator(2), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  trip.name
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '3' })
              )];
            case 'LocalExpertProfile':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  localExpert.name.first + ' ' + localExpert.name.last
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
              )];
            case 'Inspirations':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Inspiration'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/inspiration '
                })
              )];
            case 'InspirationDetail':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'a',
                  { itemProp: 'item', href: '/inspiration' },
                  _react3.default.createElement(
                    'span',
                    { styleName: 'breadcrumb-item', itemProp: 'name' },
                    'Inspiration'
                  ),
                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
                )
              ), separator(2), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  inspiration.name
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '3' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/inspiration/' + inspiration.slug
                })
              )];
            case 'Career':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Career'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/career'
                })
              )];
            case 'TrustAndSafety':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Trust & Safety'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/trust-and-safety'
                })
              )];
            case 'Dtac':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Dtac'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
              )];
            case 'Digi':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Digi'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/digi'
                })
              )];
            case 'LocalExpertBenefits':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Local Expert Benefits'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/local-expert-benefits'
                })
              )];
            case 'Sitemap':
              return [separator(1), _react3.default.createElement(
                'span',
                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
                _react3.default.createElement(
                  'span',
                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
                  'Sitemap'
                ),
                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
                _react3.default.createElement('meta', {
                  itemProp: 'item',
                  itemType: 'http://schema.org/WebPage',
                  content: _config2.default.baseURL.en + '/sitemap'
                })
              )];
            default:
              return null;
          }
        }()
      );
    }
  }]);
  return Breadcrumbs;
}(_react2.Component), _class2.propTypes = {
  type: _react2.PropTypes.string.isRequired,
  trip: _react2.PropTypes.object,
  localExpert: _react2.PropTypes.object,
  inspiration: _react2.PropTypes.object,
  customStyle: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Breadcrumbs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/Breadcrumbs.js
// module id = 63
// module chunks = 0 2 7 9 12 13 14 17 20 38 41